import classes from './table.module.css'

const Table = {
  classNames: {
    table: classes.table,
  },
}

export default Table
